import styled from "styled-components";
import { Box, ButtonBase, Typography } from "@mui/material";
import { OuterWrapper } from "../wrapper/wrapper";

export const HeroBackground = styled(OuterWrapper)`
  && {
    height: 500px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
`;

export const QuoteText = styled(Typography)`
  && {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 0.05em;
    color: #ffffff;
  }
`;

export const HeroTitle = styled(Typography)`
  && {
    font-family: "Noto Serif";
    font-style: normal;
    font-weight: 600;
    text-align: center;
    letter-spacing: 0.05em;
    color: #ffffff;
  }
`;

export const CTAButton = styled(ButtonBase)`
  && {
    background: #f2753b;
    box-shadow: -2px 2px 2px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    padding: 13px 30px;

    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #ffffff;
  }
`;

export const Container = styled(Box)`
  && {
    background: #eaeef2;
    border-radius: 15px;
    padding-top: 30px;
    min-height: 300px;
  }
`;

export const Title = styled(Typography)`
  && {
    font-family: "Noto Serif";
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
    letter-spacing: 0.05em;
    color: #000000;
    margin-bottom: 17px;
  }
`;

export const Details = styled(Typography)`
  && {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 30px;
    letter-spacing: 0.1em;
    color: #000000;
  }
`;

export const PricingContainer = styled(Box)`
  && {
    background: #eaeef2;
    box-shadow: -2px 2px 2px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
  }
`;

export const TypeTile = styled(Typography)`
  && {
    font-family: "Noto Serif";
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
    letter-spacing: 0.05em;
    color: #ffffff;
    padding: 12px 0px;
    text-align: center;
    text-transform: capitalize;

    margin-bottom: 25px;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    background: ${(props) =>
      props.type === "intermediate"
        ? `linear-gradient(90deg, #915BFE 0%, #462587 100%)`
        : props.type === "advance"
        ? `linear-gradient(90deg, #00C884 0%, #207054 100%)`
        : `linear-gradient(89.93deg, #d70011 0.06%, #8c2029 101.8%)`};
  }
`;

export const GSTText = styled(Typography)`
  && {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
  }
`;
